
import { useEffect, useRef, useState } from 'react';

const images = [
  { src: '/images/unnamed(1).jpg', alt: '' },
  { src: '/images/unnamed(2).jpg', alt: '' },
  { src: '/images/unnamed(3).jpg', alt: '' },
  { src: '/images/unnamed(4).jpg', alt: '' },
  { src: '/images/galeria1.jpg', alt: '' },
  { src: '/images/galeria2.jpg', alt: '' },
  { src: '/images/galeria3.jpg', alt: '' },
  { src: '/images/galeria4.jpg', alt: '' },
  { src: '/images/galeria5.jpg', alt: '' },
  { src: '/images/galeria6.jpg', alt: '' },
  { src: '/images/galeria7.jpg', alt: '' },
  { src: '/images/galeria8.jpg', alt: '' },
  { src: '/images/galeria9.jpg', alt: '' },
  { src: '/images/galeria10.jpg', alt: '' },
  { src: '/images/galeria11.png', alt: '' },
  { src: '/images/galeria12.jpg', alt: '' },
  { src: '/images/galeria13.jpg', alt: '' },
  { src: '/images/galeria14.png', alt: '' },
];

const Gallery = () => {
  const titleRef = useRef(null);
  const [titleVisible, setTitleVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTitleVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (titleRef.current) observer.observe(titleRef.current);
    return () => observer.disconnect();
  }, []);

  // Auto-play do carousel mobile
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 4000); // Muda a cada 4 segundos

    return () => clearInterval(timer);
  }, []);

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  };

  return (
    <section id="galeria" className="py-20 bg-gradient-to-br from-gray-800 to-gray-900">
      <div className="container mx-auto px-6">
        <h2 
          ref={titleRef}
          className={`text-4xl font-bold text-center text-white mb-4 ${titleVisible ? 'animate-on-scroll' : 'opacity-0'}`}
        >
          Galeria de Imagens
        </h2>
        <p className="text-center text-gray-300 mb-12 max-w-2xl mx-auto">
          Veja exemplos de instalações, ferramentas e conteúdo do nosso curso
        </p>
        
        {/* Grid Desktop */}
        <div className="hidden md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {images.map((image, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
            >
              <img 
                src={image.src} 
                alt={image.alt}
                className="w-full h-64 object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-white font-semibold text-sm">{image.alt}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Carrossel Mobile */}
        <div className="md:hidden max-w-md mx-auto relative">
          <div className="relative overflow-hidden rounded-lg shadow-2xl">
            {/* Imagens do Carrossel */}
            <div 
              className="flex transition-transform duration-500 ease-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {images.map((image, index) => (
                <div key={index} className="min-w-full">
                  <img 
                    src={image.src} 
                    alt={image.alt}
                    className="w-full h-80 object-cover"
                  />
                  {image.alt && (
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4">
                      <p className="text-white font-semibold text-sm">{image.alt}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Botão Anterior */}
            <button
              onClick={goToPrevious}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 rounded-full transition-all duration-200"
              aria-label="Imagem anterior"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            {/* Botão Próximo */}
            <button
              onClick={goToNext}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 rounded-full transition-all duration-200"
              aria-label="Próxima imagem"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          {/* Indicadores (dots) */}
          <div className="flex justify-center mt-4 gap-2 flex-wrap">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`transition-all duration-300 rounded-full ${
                  currentSlide === index 
                    ? 'bg-[#E18E37] w-6 h-2' 
                    : 'bg-gray-400 w-2 h-2'
                }`}
                aria-label={`Ir para imagem ${index + 1}`}
              />
            ))}
          </div>

          {/* Contador */}
          <div className="text-center mt-3 text-gray-300 text-sm">
            {currentSlide + 1} / {images.length}
          </div>
        </div>

        <div className="text-center mt-12">
          <div className="inline-block bg-[#E18E37] rounded-lg p-4 md:p-6 shadow-xl max-w-full md:max-w-md mx-auto">
            <img 
              src="/images/unnamed(5).png" 
              alt="Certificado Reconhecido" 
              className="w-full max-w-xs mx-auto mb-4"
            />
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
              Certificado Reconhecido
            </h3>
            <p className="text-sm md:text-base text-gray-800">
              Receba seu certificado de conclusão ao finalizar o curso
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
